// API base URL is resolved per-environment via REACT_APP_API_BASE_URL.
// `npm run local` sets http://localhost:5001. Staging and production use their env files.
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api.myactivity.in'